import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Navbar, Footer } from "../components/Layout";
import { BlockRenderer } from "../components/Blocks";
import { Helmet } from "../components/Helmet";
import TopPromoBanner from "../components/TopPromoBanner";
import QuickCallbackForm from "../components/QuickCallbackForm";

const isLoiretPage = (slug) => typeof slug === "string" && slug.startsWith("locaux-activite-");

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get(`/pages/${slug}`).then(r => {
      setPage(r.data);
    }).catch(() => setNotFound(true));
    api.get("/testimonials").then(r => setTestimonials(r.data)).catch(() => {});
    api.get("/partners").then(r => setPartners(r.data)).catch(() => {});
  }, [slug]);

  if (notFound) return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <div className="p-24 text-center font-mono text-sm">Page introuvable.</div>
      <Footer />
    </div>
  );
  if (!page) return <div className="p-24 text-center font-mono text-sm">Chargement...</div>;

  const loiret = isLoiretPage(slug);
  const callbackSource = loiret ? slug.replace("locaux-activite-", "") : slug;

  return (
    <div className="min-h-screen bg-[#F9F9F7]" data-testid={`dynamic-page-${slug}`}>
      <Helmet
        title={page.meta_title || page.title}
        description={page.meta_description}
        ogImage={page.og_image}
        path={`/p/${slug}`}
        schema={page.schema_jsonld || undefined}
      />
      {loiret && <TopPromoBanner />}
      <Navbar />
      {(page.blocks || []).map((b, i) => (
        <BlockRenderer key={b._uid || `dyn-${i}`} block={b} testimonials={testimonials} partners={partners} />
      ))}
      {loiret && (
        <section className="max-w-4xl mx-auto px-6 md:px-8 py-16">
          <QuickCallbackForm source={callbackSource} />
        </section>
      )}
      <Footer />
    </div>
  );
}
